// eslint-disable-next-line
import {
  CustomUserLayout,
  IndependentServiceLayout,
  UserLayout,
  BasicLayout,
  RouteView,
  BlankLayout,
  PageView,
  CustomBasicLayout,
  CustomServiceLayout,
  CustomProGroupLayout
} from '@/layouts'
import { bxAnaalyse } from '@/core/icons'
import { platformRouter } from './module/platformRouter.config'
// import {productRouter} from "./module/productRouter.config"
import { overviewRouter } from './module/overviewRouter.config'
import { dashboardRouter } from './module/dashboardRouter.config'
import { distributionRouter } from './module/distributionRouter.config'
import { userRouter } from './module/userRouter.config'
import { financeRouter } from './module/financeRouter.config'
import { orderRouter } from './module/orderRouter.config'
import { serviceRouter } from './module/serviceRouter.config'
import { settingRouter } from './module/settingRouter.config'
import { goodsRouter } from '@/config/module/goodsRouter.config'
import { serviceProviderList } from '@/config/module/serviceProviderRouter.config'
import { goodsGroupRouterList } from '@/config/module/goodsGroupRouter.config'

const menus = [
  ...overviewRouter,
  ...platformRouter,
  ...goodsRouter,
  ...orderRouter,
  ...financeRouter,
  ...userRouter,
  ...dashboardRouter,
  ...distributionRouter,
  ...serviceRouter,
  ...settingRouter
]
export const asyncRouterMap = [
  {
    path: '/',
    component: CustomBasicLayout,
    meta: { title: '首页' },
    redirect: '/home',
    children: [...menus]
  },
  {
    path: '/goods/group',
    component: CustomProGroupLayout,
    meta: { title: '', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true },
    hidden: true,
    ignorePermissions: true,//忽略权限控制(忽略的包括里面的所有孩子)
    hidePermissionTree: true,//在权限树中隐藏
    children: [...goodsGroupRouterList]
  },
  {
    path: '/service/group',
    component: CustomServiceLayout,
    meta: { title: '', keepAlive: false, hideInMenu: true, hidePermissionTree: true, ignorePermissions: true },
    hidden: true,
    ignorePermissions: true,//忽略权限控制(忽略的包括里面的所有孩子)
    hidePermissionTree: true,//在权限树中隐藏
    children: [...serviceProviderList]
  },
  {
    path: '*', redirect: '/404', hidden: true,
    meta: { hideInMenu: true }
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/users',
    component: CustomUserLayout,
    redirect: '/users/login',
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        meta: { title: '注册', type: 1 },
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      },
      {
        path: 'resetPassword',
        name: 'resetPassword',
        meta: { title: '重置密码', type: 2 },
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      },
      {
        path: 'register-result',
        name: 'registerResult',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/RegisterResult')
      },
      {
        path: 'authorization',
        name: 'Authorization',
        component: () => import('@/views/user/Authorization')
      },
      {
        path: 'contacts/import',
        name: 'ImportContacts',
        meta: {
          title: '批量导入联系人'
        },
        component: () => import('@/views/user/contacts/ImportContacts')
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  },
  {
    path: '/service/cloud',
    component: IndependentServiceLayout,
    meta: { title: '', keepAlive: false },
    children: [
      {
        path: '/service/moFangCloud',
        name: 'MoFangCloud',
        component: () => import('@/views/service/serviceProvider/moFangCloud/MoFangCloud'),
        meta: {
          title: '魔方云直连',
          keepAlive: false
        }
      }
    ]////魔方云服务相关路由
  }

]
